<template>
  <el-dialog
    :visible="visible"
    title="СТАТИСТИКА ЗВОНКОВ"
    width="80%"
    class="stats-modal"
    @close="$emit('close')"
  >
    <el-table :data="calls" empty-text="Нет данных">
      <el-table-column prop="user_id" label="Кто звонил" align="center">
        <template slot-scope="scope">
          {{ getName(scope.row.user_id) }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Дата" align="center">
        <template slot-scope="scope">
          {{ dateToFormat(scope.row.created_at, 'respStatusDate') }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Статус" align="center">
        <template slot-scope="scope">
          {{ getStatus(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="task_type" label="Тип задания" align="center">
        <template slot-scope="scope">
          <el-popover placement="right" width="400" trigger="click">
            <el-row>
              <p>
                <b>Назначена на {{ getName(scope.row.user_id) }}</b>
              </p>
              <p>
                <b>Описание задания:</b><br />
                {{ scope.row.task_description || 'нет данных' }}
              </p>
            </el-row>
            <el-button slot="reference" type="text">
              {{ getTaskStatus(scope.row.task_type) }}
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="Комментарий" align="center" />
    </el-table>
  </el-dialog>
</template>

<script>
import { callStatuses, taskTypes } from '@/views/CallCenter/constants'
import { mapGetters } from 'vuex'

export default {
  name: 'StatsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    calls: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      callStatuses,
    }
  },
  computed: {
    ...mapGetters({ getList: 'callCenter/getList' }),
    admins() {
      return this.getList('admins')
    },
  },
  methods: {
    getStatus(status) {
      return callStatuses[status] || 'без статуса'
    },
    getTaskStatus(status) {
      return taskTypes[status] || 'без типа'
    },
    getName(id) {
      const admin = this.admins.find(a => a.id === id) || {}

      return this.shortFio(admin.fio) + ' тел: ' + admin.login
    },
  },
}
</script>

<style lang="sass">
.stats-modal
  font-family: Rubik, sans-serif
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .el-table th
    display: table-cell !important
</style>
